import { render, staticRenderFns } from "./Extracurriculares.vue?vue&type=template&id=3e39df6e&scoped=true&"
import script from "./Extracurriculares.vue?vue&type=script&lang=js&"
export * from "./Extracurriculares.vue?vue&type=script&lang=js&"
import style0 from "./Extracurriculares.vue?vue&type=style&index=0&id=3e39df6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39df6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VDivider,VFlex,VLayout})
